import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-black/8 py-12 px-5">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2.5 mb-2">
            <div className="w-7 h-7 rounded-lg bg-[#f59e0b] flex items-center justify-center text-sm">🏏</div>
            <span className="font-bold text-base text-black">Town Square <span className="text-[#f59e0b]">Arena</span></span>
          </div>
          <p className="text-black/40 text-sm">Hyderabad's premier multi-sport facility.</p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap gap-6 text-sm">
          {[
            ["Book a Slot", "/book"],
            ["Cancellation Policy", "/cancellation-policy"],
            ["Terms & Conditions", "/terms"],
            ["Privacy Policy", "/privacy"],
            ["FAQ", "/faq"],
            ["Admin", "/admin"],
          ].map(([label, to]) => (
            <Link key={to} to={to} className="text-black/40 hover:text-black transition-colors">{label}</Link>
          ))}
        </div>

        <p className="text-black/30 text-xs">© 2026 Town Square Arena. All rights reserved.</p>
      </div>
    </footer>
  );
}
